import React, { useCallback, useEffect } from 'react'

import { useEventListener } from '../../hooks/useEventListener'
import { CustomEventType } from '../../types/events/CustomEventType.enum'
import { RedirectorEventDetail } from '../../types/events/RedirectorEventDetail.type'
import { REDIRECT_TIMEOUT_MS } from './constants'
import {
  RedirectConfig,
  RedirectorSeamlessTransitionConfig
} from './Redirector.type'

declare global {
  interface Window {
    _satellite?: {
      track: (event: string, data?: Record<string, unknown>) => void
    }
  }
}

export type SeamlessTransitionRedirectorProps = Omit<
  RedirectorSeamlessTransitionConfig,
  'variant'
>

export const SeamlessTransitionRedirector: React.FC<
  SeamlessTransitionRedirectorProps
> = ({ config, selectedItem, source }) => {
  const getMatch = useCallback(
    (selectedItem: string | undefined): RedirectConfig | undefined => {
      return (config ?? []).find(item => item.key === selectedItem)
    },
    [config]
  )

  useEventListener(
    CustomEventType.REDIRECTOR_EVENT,
    (event: CustomEvent<RedirectorEventDetail>) => {
      const { action } = event.detail
      const match = getMatch(selectedItem)
      if (action === 'processed' && match?.url) {
        if (window.parent) {
          window.parent.location.replace(match.url)
        } else {
          window.location.replace(match.url)
        }
      }
    }
  )

  useEffect(() => {
    const match = getMatch(selectedItem)
    if (!match) {
      console.error('No match found for provided item or query param value')
      return
    }
    setTimeout(() => {
      if (window.parent) {
        window.parent.location.replace(match.url)
      } else {
        window.location.replace(match.url)
      }
    }, REDIRECT_TIMEOUT_MS)

    const checkAdobeLaunchReady = () => {
      if (window._satellite && typeof window._satellite.track === 'function') {
        window._satellite.track(CustomEventType.REDIRECTOR_EVENT, {
          action: 'pending',
          payload: {
            selectedItem: selectedItem ?? '',
            url: match?.url ?? '',
            source: source
          }
        })
      } else {
        setTimeout(checkAdobeLaunchReady, 100)
      }
    }
    checkAdobeLaunchReady()
  }, [config, selectedItem, getMatch, source])

  return null
}
